import { Button, Chip, Stack, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import PlayPauseAlbumButton from '../../../utils/PlayPauseAlbumButton';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import { Link } from 'react-router-dom';

var buttonStyle = {color: '#fff', p: 1, minWidth: '16px', borderRadius: '32px'}
var buttonsContainerStyle = {backgroundColor: '#000000D0', p: 1, m: 2, borderRadius: '32px', height: '32px', pointerEvents: 'all', position: 'absolute', bottom: 0}
var rankChipStyle = {fontWeight: 900, fontSize: '1rem'}
var albumInfos = {
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 10,
    width: '100%', 
    height: '100%', 
    opacity: 0,
    borderRadius: '16px',
    animation: 'fadeOut .2s',
    m: 1
}
interface AlbumFocusHoverProps {
    albums: [any], 
    currentIndex: number, 
    action:(index:number) => void
}

const AlbumFocusHover = ({albums, currentIndex, action}:AlbumFocusHoverProps) => {

    const showNextArtist = () => {
        if (currentIndex + 1 === albums.length || currentIndex > albums.length) {
            action(0)
        } else {
            action(currentIndex + 1)
        }
    }

    const showPreviousArtist = () => {
        if (currentIndex - 1 === -1 || currentIndex < 0) {
            action(albums.length - 1)
        } else {
            action(currentIndex - 1)
        }
    }

    return (
        <Stack className='albumInfos' sx={albumInfos}>

            <Stack direction={'row'} alignItems={'center'} sx={{mb: 1}}>
                <Stack direction={'column'} sx={{backgroundColor: '#000000D0', borderRadius: '16px', p: 2, '& a' : { textDecoration: 'none'}, pointerEvents: 'all'}}>
                    <Typography textAlign={'left'} sx={{color: '#fff', fontWeight: 700}}>
                        <Link to={`/album/${albums[currentIndex]?._id}`} >{ albums[currentIndex]?.apple_name }</Link>
                    </Typography>

                    <Typography textAlign={'left'} sx={{color: '#fff', fontWeight: 300}}>
                        { albums[currentIndex]?.apple_artist_name }
                    </Typography>
                </Stack>
            </Stack>

            <Stack direction={'row'} alignItems={'center'} >
                <Stack direction={'row'} alignItems={'center'} sx={{ backgroundColor: '#000000D0', borderRadius: '32px', height: '32px', p: 1, pr: 2}} >
                    <Chip color={'secondary'} key={currentIndex} label={'#'+ (currentIndex+1)} sx={rankChipStyle}/>
                    <FormatListNumberedIcon sx={{fontSize: '1.2rem', m: 1}}/>
                    <Typography textAlign={'left'} sx={{color: '#fff', fontWeight: 700, fontSize: '1.2rem'}}>{ albums[currentIndex].topTrackCount + "/" + albums[currentIndex].apple_track_count }</Typography>
                </Stack>
            </Stack>

            <Stack direction={'row'} alignSelf={{xs: 'center'}} sx={buttonsContainerStyle}>
                <Button onClick={() => showPreviousArtist()} sx={buttonStyle} ><NavigateBeforeIcon /></Button>
                <PlayPauseAlbumButton style={buttonStyle} album={albums[currentIndex]} />
                <Button onClick={() => showNextArtist()} sx={buttonStyle} ><NavigateNextIcon /></Button>
            </Stack>

        </Stack>
    )
}

export default AlbumFocusHover